import moment from "moment";

export interface DomainFieldwork {
  advisorName: string;
  area: string;
  brand: string;
  channel: string;
  caseNumber: string;
  contactAttemptedStatus: string;
  customerEmail: string;
  customerName: string;
  customerPhone: string;
  dateCleaned: string; //timestamp
  dateCleanedStatus: string; //timestamp
  dealerCode: string;
  dealerName: string;
  deliveredDate: number; //timestamp
  eventDate: string; //timestamp
  expiredDate: string; //timestamp
  externalCustomerID: string;
  externalRecordID: string;
  externalSeID: string;
  feedbackType: string;
  firstReminderDate: string; //timestamp
  importedDate: string; //timestamp
  importerName: string;
  initialInvitationDate: string; //timestamp
  interviewOpenedDate: string; //timestamp
  interviewStartedDate: number; //timestamp
  interviewStatus: string;
  interviewdate: string; //timestamp
  interviewDate: string; //timestamp
  market: string;
  modelName: string;
  vehicle: string;
  engine: string;
  regionName: string;
  rejectedReason: string;
  discardType: string;
  salesPerson: string;
  statusDate: number; //timestamp
  surveyId: string;
  uploadId: string;
  vin: string;
  wipNumber: string;
  zone: string,
  dealerGroupName: string,
  outletCode: string,
  outletName: string,
  agentCode: string,
  agentName: string,
  emailDiscardReason: string,
  mobileDiscardReason: string,
  secondReminderDate: string, //timestamp
  invitationDeliveryStatus: string,
  emailDeliveryDate: string, //timestamp
  mobileDeliveryDate: string, //timestamp
  receivedSurveyConfirmation: string,
}

export class Fieldwork {
  advisorName: string = "";
  area: string = "";
  brand: string = "";
  caseNumber: string = "";
  contactAttemptedStatus: string = "";
  customerEmail: string = "";
  customerName: string = "";
  customerPhone: string = "";
  dateCleanedStatus: string = "";
  dealerCode: string = "";
  dealerName: string = "";
  eventDate: string | Date = "";
  expiredDate: string | Date = "";
  externalCustomerID: string = "";
  externalRecordID: string = "";
  externalSeID: string = "";
  feedbackType: string = "";
  firstReminderDate: string | Date = "";
  importedDate: string | Date = "";
  importerName: string = "";
  initialInvitationDate: string | Date = "";
  interviewOpenedDate: string | Date = "";
  interviewStartedDate: string | Date = "";
  interviewStatus: string = "";
  interviewDate: string | Date = "";
  interviewdate: string | Date = "";
  market: string = "";
  modelName: string = "";
  vehicle: string = "";
  engine: string = "";
  regionName: string = "";
  surveyId: string = "";
  uploadId: string = "";
  vin: string = "";
  wipNumber: string = "";
  zone: string = "";
  dealerGroupName = "";
  outletCode: string = "";
  outletName: string = "";
  agentCode: string = "";
  agentName: string = "";
  emailDiscardReason: string = "";
  mobileDiscardReason: string = "";
  dateCleaned: string | Date = "";
  secondReminderDate: string | Date = "";
  invitationDeliveryStatus: string = "";
  emailDeliveryDate: string | Date = "";
  mobileDeliveryDate: string | Date = "";
  receivedSurveyConfirmation: string = "";
  rejectedReason: string = "";
  discardType: string = "";
  channel: string = "";
  orderCustomerTypeSource: string = "";
  orderCustomerType: string = "";
  orderCustomerSubtypeSource: string = "";
  orderCustomerSubtype: string = "";
  promotionCode: string = "";
  caseOrigin: string = "";
  categoryLevel5: string = "";
  caseOwner: string = "";
  recallCode: string = "";
  recallDescription: string = "";
  recallFlag: string = "";
  takataFlag: string = "";
  caseSourceDetail: string = "";
  recordType: string = "";
  caseType: string = "";
  caseReason: string = "";
  categoryLevel1: string = "";
  categoryLevel2: string = "";
  categoryLevel3: string = "";
  categoryLevel4: string = "";
  closeReasonL1: string = "";
  caseSurveyAcceptance: string = "";
  caseOpenDate: string | Date = "";
  caseClosedDate: string | Date = "";
  callType: string = "";


  constructor(data: DomainFieldwork) {
    Object.assign(this, data);
    this.dateCleanedStatus = data.dateCleanedStatus;
    this.eventDate = this.parseDate(data.eventDate);
    this.expiredDate = this.parseDate(data.expiredDate);
    this.firstReminderDate = this.parseDate(data.firstReminderDate);
    this.importedDate = this.parseDate(data.importedDate);
    this.initialInvitationDate = this.parseDate(data.initialInvitationDate);
    this.interviewOpenedDate = this.parseDate(data.interviewOpenedDate);
    this.interviewStartedDate = this.parseDate(data.interviewStartedDate);
    this.interviewDate = this.parseDate(data.interviewDate);
    this.interviewdate = this.parseDate(data.interviewdate);
    this.dateCleaned = this.parseDate(data.dateCleaned);
    this.secondReminderDate = this.parseDate(data.secondReminderDate);
    this.emailDeliveryDate = this.parseDate(data.emailDeliveryDate);
    this.mobileDeliveryDate = this.parseDate(data.mobileDeliveryDate);
  }

  private parseDate(timestamp: number | string) {
    if (typeof timestamp === 'string') {
      // Check if timestamp is in "DD/MM/YYYY" format
      const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      if (dateRegex.test(timestamp)) {
        return timestamp; // Return the string as-is if it matches the format
      }
  
      // Check if timestamp is a valid Unix timestamp (numeric string)
      const numericRegex = /^\d+$/;
      if (numericRegex.test(timestamp)) {
        let numericTimestamp = parseInt(timestamp);
        let date = new Date(numericTimestamp);
        // Check if the date is valid (e.g., timestamp is not NaN or Infinity)
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
    } else if (typeof timestamp === 'number' && !isNaN(timestamp)) {
      // Assuming timestamp is a valid Unix timestamp number
      let date = new Date(timestamp);
      // Check if the date is valid (e.g., timestamp is not NaN or Infinity)
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
    
    return ""; // Return empty string if timestamp is not valid
  }
}

